import { Badge, Box, Container, Paper, Stack, Text, Title, Anchor } from "@mantine/core";
import { Link } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";
import BrandLogoName from "../components/BrandLogoName";
import React from "react";

interface LegalPageLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export default function LegalPageLayout({
  title,
  lastUpdated,
  children,
}: LegalPageLayoutProps) {
  return (
    <Box
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "40px 20px",
      }}
    >
      <Container size={720}>
        <Paper
          withBorder
          shadow="xl"
          p={{ base: 24, sm: 40 }}
          radius="lg"
          style={{ backgroundColor: "white" }}
        >
          <Stack align="center" gap={4} mb="lg">
            <BrandLogoName />
            <Title order={2} size="h3" fw={600} mt="xs">
              {title}
            </Title>
            <Badge color="grape" variant="light" size="sm">
              Internal Use Only — Thinkcloudly Staff
            </Badge>
            <Text size="xs" c="dimmed">
              Last updated: {lastUpdated}
            </Text>
          </Stack>

          <Stack gap="md">{children}</Stack>

          <Anchor
            component={Link}
            to="/login"
            size="sm"
            mt="xl"
            display="flex"
            style={{ alignItems: "center", gap: 6, justifyContent: "center" }}
          >
            <IconArrowLeft size={16} />
            Back to Login
          </Anchor>
        </Paper>
      </Container>
    </Box>
  );
}
